/* po-cart-addons.js — complemento (carrossel "Complete your order") e seguro de frete da gaveta do carrinho.
   Configuração vem de window.poCartCfg (snippets/po-cart-addons-script.liquid). Markup: snippets/po-cart-addons.liquid
   e snippets/po-cart-addon-card.liquid. Arquivo em assets/ para o navegador guardar em cache (não pesa em cada página). */
(function () {
  if (window.poCartAddons) return;
  window.poCartAddons = true;
  var C = window.poCartCfg || {};
  var SEG_PROD = C.segProd || 0, SEG_VAR = C.segVar || 0;
  var SEG_ATIVO = !!C.segAtivo && SEG_VAR > 0, SEG_PADRAO = !!C.segPadrao;
  var BRINDE = C.brinde || 0;
  var TXT = C.txt || { add: 'Add', added: 'Added', indisp: 'Unavailable' };
  var K_RECUSA = 'po-seguro-recusado', K_ADD = 'po-seguro-adicionado';
  var fetchBase = window.fetch;
  var mc = document.getElementById('mini-cart');
  if (!mc) return;

  function lembrar(k, v) { try { v ? sessionStorage.setItem(k, '1') : sessionStorage.removeItem(k); } catch (e) {} }
  function lembrado(k) { try { return sessionStorage.getItem(k) === '1'; } catch (e) { return false; } }
  function pedir(url, corpo) {
    var o = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (corpo) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(corpo); }
    return fetchBase.call(window, url, o).then(function (r) { return r.json(); });
  }
  function carrinho() { return pedir('/cart.js'); }
  function tirarVarias(chaves) { // numa chamada só: a chave de cada linha muda depois de qualquer alteração
    if (!chaves.length) return Promise.resolve();
    var u = {}; chaves.forEach(function (k) { u[k] = 0; });
    return pedir('/cart/update.js', { updates: u });
  }
  function adicionar(variante, props) {
    var item = { id: parseInt(variante, 10), quantity: 1 };
    if (props) item.properties = props;
    return pedir('/cart/add.js', { items: [item] });
  }
  function eComp(i) { return i.properties && i.properties._po_complemento; }

  /* fila: uma operação por vez */
  var fila = Promise.resolve();
  function naFila(fn) { var p = fila.then(fn, fn); fila = p.catch(function () {}); return p; }
  var intencao = { seguro: null, comp: {} }; // o que o cliente acabou de pedir e ainda está sendo feito
  var rolagemCarrossel = 0;

  /* redesenho da gaveta: vale o pedido mais recente, depois que a fila esvazia */
  var seq = 0, espera = null;
  function redesenhar() {
    if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
    clearTimeout(espera);
    espera = setTimeout(function () { fila.then(function () {
      var meu = ++seq;
      fetchBase.call(window, '/cart?view=mini-cart&timestamp=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (meu !== seq) return;
          var d = document.createElement('div'); d.innerHTML = html;
          var novo = d.querySelector('.mini-cart'); if (!novo) return;
          var lista = mc.querySelector('.mini-cart__line-item-list'), topo = lista ? lista.scrollTop : 0;
          var trilho = mc.querySelector('[data-po-trilho]'); rolagemCarrossel = trilho ? trilho.scrollLeft : 0;
          mc.innerHTML = novo.innerHTML;
          var qtd = novo.getAttribute('data-item-count');
          mc.setAttribute('data-item-count', qtd);
          document.querySelectorAll('.header__cart-count').forEach(function (e) { e.textContent = qtd; });
          lista = mc.querySelector('.mini-cart__line-item-list'); if (lista) lista.scrollTop = topo;
        })
        .catch(function () { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { scrollToTop: false } })); });
    }); }, 120);
  }
  window.poGavetaAtualizar = redesenhar;

  /* seguro + complementos: plano usado pelo brinde-automatico (mesma leitura do carrinho, mesma chamada de adicionar).
     "principais" = produtos escolhidos pelo cliente; sem eles, complemento da gaveta e seguro saem junto. */
  window.poSeguroPlano = function (itens) {
    var r = { adicionar: [], tirar: [] };
    var principais = 0, seg = [], comps = [];
    (itens || []).forEach(function (i) {
      if (i.product_id === SEG_PROD) seg.push(i);
      else if (eComp(i)) comps.push(i);
      else if (i.product_id !== BRINDE) principais += i.quantity;
    });
    if (!principais) comps.forEach(function (i) { r.tirar.push(i.key); });
    if (!SEG_ATIVO) return r;
    seg.slice(1).forEach(function (i) { r.tirar.push(i.key); });
    if (!principais) { lembrar(K_RECUSA, false); lembrar(K_ADD, false); seg.slice(0, 1).forEach(function (i) { r.tirar.push(i.key); }); return r; }
    if (seg.length) {
      lembrar(K_ADD, true);
      if (seg[0].quantity !== 1) { r.tirar.push(seg[0].key); r.adicionar.push({ id: SEG_VAR, quantity: 1 }); }
      return r;
    }
    if (lembrado(K_ADD)) { lembrar(K_RECUSA, true); lembrar(K_ADD, false); return r; } // tirado na página do carrinho
    if (!SEG_PADRAO || lembrado(K_RECUSA) || intencao.seguro === false) return r;
    lembrar(K_ADD, true);
    r.adicionar.push({ id: SEG_VAR, quantity: 1 });
    return r;
  };
  function sincronizar() {
    return carrinho().then(function (c) {
      var r = window.poSeguroPlano(c.items || []), p = Promise.resolve(false);
      if (r.tirar.length) p = tirarVarias(r.tirar).then(function () { return true; });
      if (r.adicionar.length) p = p.then(function () { return pedir('/cart/add.js', { items: r.adicionar }); }).then(function () { return true; });
      return p;
    });
  }
  function conferir() {
    if (window.poBrindeSincronizar) { window.poBrindeSincronizar(); return; }
    naFila(sincronizar).then(function (mudou) { if (mudou) redesenhar(); }, function () {});
  }
  var agendado = null;
  function agendarSinc(ms) {
    clearTimeout(agendado);
    agendado = setTimeout(function () {
      if (window.poBrindeSinc) return; // o brinde já confere
      naFila(sincronizar).then(function (mudou) { if (mudou) redesenhar(); }, function () {});
    }, ms);
  }

  /* ---------- carrossel ---------- */
  function dinheiro(c) {
    var f = (window.theme && window.theme.moneyFormat) || '$' + '{' + '{amount}}';
    function fmt(d, mil, dec) { var s = (c / 100).toFixed(d).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil); return s.join(dec); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return fmt(2, "'", '.');
      return fmt(2, ',', '.');
    });
  }
  function numero(t) {
    var ns = String(t || '').match(/\d+([.,]5)?/g) || [];
    for (var i = 0; i < ns.length; i++) { var n = parseFloat(ns[i].replace(',', '.')); if (n >= 1 && n <= 60) return n; } // US/UK (1–20) e EU (30–52)
    return null;
  }
  function numeros(t) {
    return (String(t || '').match(/\d+([.,]5)?/g) || []).map(function (x) { return parseFloat(x.replace(',', '.')); }).filter(function (n) { return n >= 1 && n <= 60; });
  }
  var GEN = /^(women|woman|men|man|unisex|kids|ladies|femme|homme|donna|uomo|damen|herren|mujer|hombre)\b/i;
  function genero(t) {
    var m = String(t || '').match(GEN); if (!m) return '';
    return /^(women|woman|ladies|femme|donna|damen|mujer)$/i.test(m[1]) ? 'w' : (/^(men|man|homme|uomo|herren|hombre)$/i.test(m[1]) ? 'm' : m[1].toLowerCase());
  }
  function dados(card) {
    if (!card._d) {
      try { card._d = JSON.parse(card.querySelector('[data-po-dados]').textContent); } catch (e) { card._d = { n: [], v: [], f: {} }; }
      card._d.vs = card._d.v.map(function (x) { return { id: x[0], o: [x[1], x[2], x[3]].slice(0, Math.max(card._d.n.length, 1)), p: x[4], c: x[5], i: x[6] }; });
    }
    return card._d;
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (x) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[x]; }); }
  function montarMenus(card) {
    var d = dados(card), box = card.querySelector('[data-po-opcoes]');
    if (!box || !d.n.length) return;
    var html = '';
    d.n.forEach(function (nome, i) {
      var vals = [];
      d.vs.forEach(function (v) { if (v.o[i] != null && vals.indexOf(v.o[i]) < 0) vals.push(v.o[i]); });
      var grupos = [], porGrupo = {};
      vals.forEach(function (x) { var m = String(x).match(GEN), g = m ? m[1] : ''; if (!(g in porGrupo)) { porGrupo[g] = []; grupos.push(g); } porGrupo[g].push(x); });
      var temGenero = grupos.some(function (g) { return g; });
      var ops = function (lista) { return lista.map(function (x) { return '<option value="' + esc(x) + '">' + esc(x) + '</option>'; }).join(''); };
      var corpo = temGenero
        ? grupos.map(function (g, k) { return (k ? '<hr>' : '') + (g ? '<optgroup label="' + esc(g) + '">' + ops(porGrupo[g]) + '</optgroup>' : ops(porGrupo[g])); }).join('')
        : ops(vals);
      html += '<select class="po-cc__sel' + (temGenero ? ' po-cc__sel--genero' : '') + '" data-po-opcao="' + i + '" aria-label="' + esc(nome) + '">' + corpo + '</select>';
    });
    box.innerHTML = html;
  }
  function selecionada(card) {
    var d = dados(card), sels = card.querySelectorAll('[data-po-opcao]');
    if (!sels.length) return d.vs[0] || null;
    var val = [].map.call(sels, function (s) { return s.value; });
    return d.vs.filter(function (v) { return v.o.every(function (x, i) { return x === val[i]; }); })[0] || null;
  }
  function marcar(card, v) { [].forEach.call(card.querySelectorAll('[data-po-opcao]'), function (s, i) { s.value = v.o[i]; }); }
  function mostrar(card) {
    var v = selecionada(card), d = dados(card);
    var preco = card.querySelector('[data-po-preco]'), btn = card.querySelector('[data-po-add]'), img = card.querySelector('[data-po-img]');
    if (v && preco) preco.innerHTML = v.c > v.p
      ? '<span class="price price--highlight">' + dinheiro(v.p) + '</span> <span class="price price--compare">' + dinheiro(v.c) + '</span>'
      : '<span class="price">' + dinheiro(v.p) + '</span>';
    var url = v && v.i ? d.f[v.i] : null;
    if (img && url && img.getAttribute('src') !== url) img.setAttribute('src', url);
    card.setAttribute('data-variante', v ? v.id : '');
    var add = card.classList.contains('is-added');
    if (btn) { btn.disabled = add || !v; btn.textContent = add ? TXT.added + ' ✓' : (v ? '+ ' + TXT.add : TXT.indisp); }
    return v;
  }
  function preEscolher(card, alvo) {
    var d = dados(card), atual = card.getAttribute('data-variante');
    var v0 = d.vs.filter(function (v) { return String(v.id) === atual; })[0];
    if (card.classList.contains('is-added') && v0) return marcar(card, v0);
    var melhor = v0 || d.vs[0], nota = 0;
    if (alvo.n) d.vs.forEach(function (v) {
      var t = v.o.join(' '), s = 0;
      if (numeros(t).indexOf(alvo.n) >= 0) s += 2; // todos os números da variante: "35-36", "Blu (1 Paio) / 35-36"
      if (alvo.g && genero(v.o.filter(function (x) { return GEN.test(x); })[0] || '') === alvo.g) s += 1;
      if (s > nota) { nota = s; melhor = v; }
    });
    if (melhor) marcar(card, melhor);
  }
  function montarCarrossel() {
    var box = mc.querySelector('[data-po-comp-box]');
    if (!box || box._pronto) return;
    box._pronto = true;
    var trilho = box.querySelector('[data-po-trilho]');
    // com o encaixe (scroll-snap) ligado, o navegador segue o cartão que estava encaixado quando a ordem muda
    // e o carrossel abria no meio: desliga o encaixe enquanto reordena e volta para o primeiro cartão
    trilho.style.scrollSnapType = 'none';
    var cards = [].slice.call(box.querySelectorAll('[data-po-cand]'));
    var fonte = box.getAttribute('data-fonte'), mem = {};
    try { mem = JSON.parse(sessionStorage.getItem('po-comp-ordem') || '{}'); } catch (e) {}
    if (!mem[fonte]) { mem[fonte] = Math.floor(Math.random() * 2147483645) + 1; try { sessionStorage.setItem('po-comp-ordem', JSON.stringify(mem)); } catch (e) {} }
    var semente = mem[fonte];
    function aleatorio() { semente = (semente * 16807) % 2147483647; return semente / 2147483647; }
    cards.sort(function (a, b) { return Number(a.getAttribute('data-po-cand')) - Number(b.getAttribute('data-po-cand')); });
    for (var i = cards.length - 1; i > 0; i--) { var j = Math.floor(aleatorio() * (i + 1)), t = cards[i]; cards[i] = cards[j]; cards[j] = t; }
    // no máximo 6 cartões. Prioridade para acessórios/meias; palmilhas: 2 (as que houver) e sempre nos 2 primeiros cartões.
    // (Se a lista tiver calçados, eles entram como antes: 4 ou 5 calçados + 1 ou 2 acessórios.) Os já adicionados sempre ficam.
    var tipo = function (c) { var t = c.getAttribute('data-po-tipo'); return t === 'acc' || t === 'ins' ? t : 'calc'; };
    var tem = { calc: 0, acc: 0, ins: 0 }; cards.forEach(function (c) { tem[tipo(c)]++; });
    var nIns = Math.min(2, tem.ins), LIM;
    if (tem.calc) { var nAcc = Math.min(aleatorio() < 0.5 ? 1 : 2, tem.acc + tem.ins); LIM = { calc: 6 - nAcc, acc: nAcc, ins: 0 }; if (nAcc > tem.acc) LIM.ins = nAcc - tem.acc; }
    else { var ins = Math.min(nIns, tem.ins); LIM = { calc: 0, acc: Math.min(tem.acc, 6 - ins), ins: ins }; }
    var usados = { calc: 0, acc: 0, ins: 0 }, fica = {};
    cards.forEach(function (c) { if (c.classList.contains('is-added')) { usados[tipo(c)]++; fica[c.getAttribute('data-po-cand')] = 1; } });
    cards.forEach(function (c) { if (fica[c.getAttribute('data-po-cand')]) return; var t = tipo(c); if (usados[t] < LIM[t]) { usados[t]++; fica[c.getAttribute('data-po-cand')] = 1; } });
    cards = cards.filter(function (c) { if (fica[c.getAttribute('data-po-cand')]) return true; c.remove(); return false; });
    cards.sort(function (a, b) { return (tipo(b) === 'ins') - (tipo(a) === 'ins'); }); // palmilhas primeiro (02/10/2026: brinde desligado)
    cards.forEach(function (c) { trilho.appendChild(c); });
    var tam = box.getAttribute('data-tamanho') || '', alvo = { n: numero(tam), g: genero((tam.split(' / ').filter(function (x) { return GEN.test(x); })[0]) || '') };
    cards.forEach(function (c) { montarMenus(c); preEscolher(c, alvo); aplicarIntencao(c); mostrar(c); });
    box.classList.toggle('po-cc--poucos', cards.length <= 2);
    marcarCaixa(box);
    trilho.scrollLeft = rolagemCarrossel || 0;
    var volta = rolagemCarrossel; rolagemCarrossel = 0;
    requestAnimationFrame(function () { trilho.scrollLeft = volta || 0; trilho.style.scrollSnapType = ''; });
  }
  function marcarCaixa(box) { if (box) box.classList.toggle('po-cc--com-add', !!box.querySelector('.po-cc.is-added')); }
  /* o que o cliente acabou de clicar aparece na hora (a Shopify confirma por trás) */
  function aplicarIntencao(card) {
    var it = intencao.comp[card.getAttribute('data-po-cand')];
    if (!it) return;
    card.classList.toggle('is-added', it.ligar);
    if (it.ligar && it.variante) { var v = dados(card).vs.filter(function (x) { return x.id === it.variante; })[0]; if (v) marcar(card, v); }
  }

  /* ---------- carrossel parado com a gaveta aberta ----------
     Qualquer redesenho da gaveta (nosso ou do tema) com a gaveta aberta e o mesmo produto principal mantém o carrossel
     que o cliente está vendo (mesmos produtos, mesma ordem, mesma rolagem); só atualiza quem está adicionado.
     Ele é montado de novo quando a gaveta é fechada e aberta, ou quando muda o produto principal. */
  var boxAtual = null, rolagemAtual = 0;
  document.addEventListener('scroll', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-po-trilho')) rolagemAtual = e.target.scrollLeft; }, true);
  function manterCarrossel() {
    var novo = mc.querySelector('[data-po-comp-box]');
    if (!novo || novo === boxAtual || !boxAtual || novo._pronto) return;
    if (mc.getAttribute('aria-hidden') !== 'false' || boxAtual.getAttribute('data-fonte') !== novo.getAttribute('data-fonte')) return;
    var estado = {};
    [].forEach.call(novo.querySelectorAll('[data-po-cand]'), function (c) {
      estado[c.getAttribute('data-po-cand')] = { add: c.classList.contains('is-added'), v: c.getAttribute('data-variante') };
    });
    novo.parentNode.replaceChild(boxAtual, novo);
    [].forEach.call(boxAtual.querySelectorAll('[data-po-cand]'), function (c) {
      var id = c.getAttribute('data-po-cand'), e = estado[id];
      if (intencao.comp[id]) return; // clique ainda em andamento: a tela já mostra o que o cliente pediu
      var add = !!(e && e.add);
      c.classList.toggle('is-added', add);
      if (add && e.v) { var v = dados(c).vs.filter(function (x) { return String(x.id) === e.v; })[0]; if (v) marcar(c, v); }
      mostrar(c);
    });
    marcarCaixa(boxAtual);
    var tr = boxAtual.querySelector('[data-po-trilho]'); if (tr) tr.scrollLeft = rolagemAtual;
    rolagemCarrossel = 0;
  }

  /* ---------- estado após cada redesenho ---------- */
  function ajustar() {
    var s = mc.querySelector('[data-po-seguro]');
    if (s && intencao.seguro !== null) { s.checked = intencao.seguro; s.closest('.po-addon').classList.add('is-busy'); }
    else if (s && s.getAttribute('data-no-carrinho') !== '1') s.checked = SEG_PADRAO && !lembrado(K_RECUSA);
    carregarPreguica();
    manterCarrossel();
    montarCarrossel();
    boxAtual = mc.querySelector('[data-po-comp-box]');
  }
  var ultimaPreguica = 0;
  function carregarPreguica() { // no máximo uma vez a cada 5 s (evita repetir se algo der errado)
    if (mc.getAttribute('aria-hidden') !== 'false' || !mc.querySelector('[data-po-comp-lazy]')) return;
    if (Date.now() - ultimaPreguica < 5000) return;
    ultimaPreguica = Date.now(); redesenhar();
  }
  new MutationObserver(ajustar).observe(mc, { childList: true });
  // o carrossel não vem no HTML da página (deixa a página leve): carrega quando a gaveta abre
  new MutationObserver(function () {
    if (mc.getAttribute('aria-hidden') === 'false') {
      rolagemAtual = 0;
      var tr = mc.querySelector('[data-po-trilho]');
      if (tr) { tr.style.scrollSnapType = 'none'; tr.scrollLeft = 0; requestAnimationFrame(function () { tr.scrollLeft = 0; tr.style.scrollSnapType = ''; }); }
    }
    carregarPreguica();
  }).observe(mc, { attributes: true, attributeFilter: ['aria-hidden'] });
  ajustar();

  /* ---------- ações ---------- */
  function acaoSeguro(ligar) {
    if (ligar) lembrar(K_RECUSA, false); else { lembrar(K_RECUSA, true); lembrar(K_ADD, false); }
    return naFila(function () {
      return carrinho().then(function (c) {
        var linhas = (c.items || []).filter(function (i) { return i.product_id === SEG_PROD; });
        if (ligar) return linhas.length ? null : adicionar(SEG_VAR).then(function () { lembrar(K_ADD, true); });
        return tirarVarias(linhas.map(function (i) { return i.key; }));
      });
    });
  }
  function acaoComp(produto, variante, ligar) {
    return naFila(function () {
      return carrinho().then(function (c) {
        var linhas = (c.items || []).filter(function (i) { return i.product_id === produto && eComp(i); });
        if (ligar && linhas.length === 1 && linhas[0].variant_id === variante) return null; // já está certo
        var p = tirarVarias(linhas.map(function (i) { return i.key; }));
        return ligar ? p.then(function () { return adicionar(variante, { _po_complemento: '1' }); }) : p;
      });
    });
  }
  var pendentes = {};
  function compAcao(card, variante, ligar) {
    var prod = card.getAttribute('data-po-cand');
    intencao.comp[prod] = { ligar: ligar, variante: variante };
    card.classList.toggle('is-added', ligar); mostrar(card); marcarCaixa(card.closest('[data-po-comp-box]')); // resposta imediata na tela
    pendentes[prod] = (pendentes[prod] || 0) + 1;
    var fim = function () {
      if (--pendentes[prod] === 0) { delete intencao.comp[prod]; delete pendentes[prod]; redesenhar(); conferir(); }
    };
    acaoComp(parseInt(prod, 10), variante, ligar).then(fim, fim);
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.closest || !el.closest('#mini-cart')) return;
    if (el.hasAttribute('data-po-seguro')) {
      el.closest('.po-addon').classList.add('is-busy');
      intencao.seguro = el.checked;
      var fimS = function () { intencao.seguro = null; redesenhar(); conferir(); };
      acaoSeguro(el.checked).then(fimS, fimS);
    } else if (el.hasAttribute('data-po-opcao')) {
      var card = el.closest('[data-po-cand]'), v = mostrar(card);
      if (card.classList.contains('is-added') && v) compAcao(card, v.id, true); // já adicionado: troca cor/tamanho
    }
  });

  /* arrastar o carrossel com o mouse (no celular o dedo já rola). Pointer capture: o arraste termina sempre que o
     botão é solto, mesmo fora da gaveta ou da janela. Depois de arrastar, o clique é engolido (não abre produto nem fecha a gaveta).
     Rolagem livre: para onde o cliente soltar, sem pular para o cartão seguinte. */
  var arraste = null, engolirClique = false;
  function fimArraste() {
    if (!arraste) return;
    var a = arraste; arraste = null;
    try { a.tr.releasePointerCapture(a.id); } catch (e) {}
    a.tr.classList.remove('is-arrastando');
    if (a.moveu) { engolirClique = true; setTimeout(function () { engolirClique = false; }, 80); } // para onde soltou (sem encaixar)
  }
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var tr = e.target.closest && e.target.closest('#mini-cart [data-po-trilho]');
    if (!tr || e.target.closest('select,button')) return;
    e.preventDefault(); // sem arrastar imagem/link nem selecionar texto
    arraste = { tr: tr, x: e.clientX, ini: tr.scrollLeft, id: e.pointerId, moveu: false };
  });
  document.addEventListener('pointermove', function (e) {
    if (!arraste || e.pointerId !== arraste.id) return;
    if (!(e.buttons & 1)) { fimArraste(); return; } // botão já foi solto
    var dx = e.clientX - arraste.x;
    if (!arraste.moveu && Math.abs(dx) > 5) { // só vira arraste depois de mover: clique simples continua abrindo o produto
      arraste.moveu = true; arraste.tr.classList.add('is-arrastando');
      try { arraste.tr.setPointerCapture(arraste.id); } catch (err) {}
    }
    if (arraste.moveu) arraste.tr.scrollLeft = arraste.ini - dx;
  });
  ['pointerup', 'pointercancel'].forEach(function (ev) { document.addEventListener(ev, fimArraste, true); });
  document.addEventListener('lostpointercapture', function () { if (arraste && arraste.moveu) fimArraste(); }, true);
  window.addEventListener('blur', fimArraste);
  window.addEventListener('click', function (e) {
    if (engolirClique) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); engolirClique = false; }
  }, true);

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-po-add],[data-po-rm],[data-po-nav]') : null;
    if (!el || !el.closest('#mini-cart')) return;
    e.preventDefault();
    if (el.hasAttribute('data-po-nav')) {
      var tr = el.closest('[data-po-comp-box]').querySelector('[data-po-trilho]');
      tr.scrollBy({ left: parseInt(el.getAttribute('data-po-nav'), 10) * tr.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    var card = el.closest('[data-po-cand]');
    if (el.hasAttribute('data-po-rm')) { compAcao(card, null, false); return; }
    if (card.classList.contains('is-added')) return;
    var v = selecionada(card);
    if (v) compAcao(card, v.id, true);
  });

  /* qualquer mudança no carrinho (tema, brinde, apps) -> confere o seguro */
  function eCarrinho(url) { return typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url); }
  window.fetch = function (entrada) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url);
    return fetchBase.apply(this, arguments).then(function (r) {
      if (eCarrinho(url)) agendarSinc(350);
      return r;
    });
  };
  var abrir = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.addEventListener('load', function () { if (eCarrinho(url)) agendarSinc(350); });
    return abrir.apply(this, arguments);
  };
  agendarSinc(0);
})();
